import React, { useMemo } from 'react';
import { RealmRoles } from '../../constants';
import useAuthService from '../../hooks/useAuthService';

const withAuthorization = (allowedRoles: RealmRoles[], WrappedComponent: React.FC) => {
  const WithAuthorization = (props: Record<string, unknown>) => {
    const { userHasRole } = useAuthService();

    const hasPermissions = useMemo(() => {
      return userHasRole(allowedRoles);
    }, [allowedRoles, userHasRole]);

    return hasPermissions && <WrappedComponent {...props} />;
  };

  WithAuthorization.displayName = `withAuthorization(${WrappedComponent.displayName || WrappedComponent.name})`;
  return WithAuthorization;
};

export default withAuthorization;
